import { Box, Typography } from "@mui/material";
import { getPlan } from "api/payment";
import PriceCard from "pages/public/home/sections/pricing/price-card";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AccountSwitcher from "component/AccountSwitcher";
import { getPlanDisplayName } from "utils/planAccess";

const PayNow = () => {
    const { plan, switchableAccounts } = useSelector(state => state.user);
    const [newPlan, setNewPlan] = useState([]);
    const planLabel = getPlanDisplayName(plan);

    useEffect(() => {
        if (!plan) return;
        const previousName = plan.previous_plan?.name || plan.planName || plan.name;
        getPlan()
            .then((res) => {
                const data = res.data;
                if (previousName === 'Pro') {
                    return setNewPlan(data.plans.filter((obj) => obj.name.includes('Pro')));
                }
                setNewPlan(data.plans);
            })
            .catch(() => setNewPlan([]));
    }, [plan]);

    return (
        <Box sx={{ minHeight: '80vh', width: '100%', px: 2, py: 4, textAlign: 'center' }}>
            <Typography sx={{ color: '#fff' }} variant="h5">
                Your {planLabel} Plan Has Expired!
            </Typography>
            {switchableAccounts?.length > 1 && (
                <>
                    <Typography sx={{ color: '#93c5fd', mt: 2, fontSize: 15 }}>
                        This account&apos;s membership has expired. Switch to your other account above if needed.
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        <AccountSwitcher />
                    </Box>
                </>
            )}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 2, mt: 4 }}>
                {newPlan.map((obj) => (
                    <PriceCard
                        key={obj._id}
                        id={obj._id}
                        amount={obj.amount}
                        features={obj.features}
                        name={`${obj.description} Plan`}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default PayNow;
